import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Spin } from 'antd';

export default function PrivateRoute({ children }) {
    const { currentUser } = useAuth();
    const location = useLocation();

    if (!currentUser) {
        // Redirect to login page but save the attempted url
        return <Navigate to="/sign-in" state={{ from: location }} replace />;
    }

    return children;
}
